import { ArrowLeft, PanelLeftClose } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { cn } from '@/shared/cn';
import { HEADER_ICON_BUTTON } from '@/shared/ui-class';
import { useSidebarState } from '@/versions/v1/shared/SidebarStateContext';
import { SidebarToggle } from './SidebarToggle';

export type SidebarSceneHeaderBack = {
  href: string;
  label: string;
};

export interface SidebarSceneHeaderProps {
  title: string;
  back?: SidebarSceneHeaderBack;
  showToggle?: boolean;
  showClose?: boolean;
  trailing?: ReactNode;
}

const TITLE_CLASS =
  'min-w-0 truncate text-sm font-semibold tracking-tight text-zinc-900 dark:text-zinc-100';

export function SidebarSceneHeader({
  title,
  back,
  showToggle = false,
  showClose = true,
  trailing,
}: SidebarSceneHeaderProps) {
  const { toggle: toggleSidebar } = useSidebarState();

  return (
    <>
      <div className="flex min-w-0 flex-1 items-center gap-2">
        {back ? (
          <Link
            to={back.href}
            aria-label={back.label}
            title={back.label}
            className={cn(HEADER_ICON_BUTTON, 'flex-shrink-0')}
          >
            <ArrowLeft className="h-4 w-4" strokeWidth={1.6} />
          </Link>
        ) : showToggle ? (
          <SidebarToggle variant="sidebar" />
        ) : null}
        <span className={TITLE_CLASS} title={title}>
          {title}
        </span>
      </div>
      <div className="flex flex-shrink-0 items-center gap-0.5">
        {trailing}
        {showClose ? (
          <button
            type="button"
            onClick={toggleSidebar}
            aria-label="Close sidebar"
            title="Close sidebar"
            className={cn(HEADER_ICON_BUTTON, 'flex-shrink-0')}
          >
            <PanelLeftClose className="h-4 w-4" strokeWidth={1.6} />
          </button>
        ) : null}
      </div>
    </>
  );
}
